import { Box } from "@mui/material";
import { memo } from "react";
import FormSectionDivider from "../formSectionDivider";
import { isTramoEditable } from "./fptTrasladosUtils";
import TramoGestionCard from "./tramoGestionCard";

const TramosGestionList = ({
  puntos = [],
  disabled,
  tiposTransporte,
  motivosTraslado,
  agencias,
  prestadoresTraslado,
  showAgencia,
  showMap = true,
  idEstadoInicial,
  idArt,
  isRepeatForm = false,
}) => {
  const tramosCount = Math.max(puntos.length - 1, 0);

  if (tramosCount < 1) return null;

  return (
    <Box sx={{ flexShrink: 0 }}>
      <FormSectionDivider title="Datos de gestión de cada tramo" />
      {puntos.slice(1).map((destino, offset) => {
        const puntoIndex = offset + 1;
        return (
          <TramoGestionCard
            agencias={agencias}
            prestadoresTraslado={prestadoresTraslado}
            destino={destino}
            disabled={
              disabled || (!isRepeatForm && !isTramoEditable(destino, idEstadoInicial))
            }
            idArt={idArt}
            key={destino.id || puntoIndex}
            motivosTraslado={motivosTraslado}
            namePrefix={`puntos.${puntoIndex}`}
            origen={puntos[offset]}
            showAgencia={showAgencia}
            showMap={showMap}
            tiposTransporte={tiposTransporte}
            tramoIndex={puntoIndex}
            tramosCount={tramosCount}
          />
        );
      })}
    </Box>
  );
};

export default memo(TramosGestionList, (prev, next) => (
  prev.disabled === next.disabled &&
  prev.showAgencia === next.showAgencia &&
  prev.showMap === next.showMap &&
  prev.idArt === next.idArt &&
  prev.tiposTransporte === next.tiposTransporte &&
  prev.motivosTraslado === next.motivosTraslado &&
  prev.agencias === next.agencias &&
  prev.prestadoresTraslado === next.prestadoresTraslado &&
  prev.idEstadoInicial === next.idEstadoInicial &&
  prev.isRepeatForm === next.isRepeatForm &&
  prev.puntos === next.puntos &&
  (prev.puntos?.length ?? 0) === (next.puntos?.length ?? 0)
));
